var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChronoxAiIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 539,
    height: 539,
    viewBox: "0 0 539 539",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19726_8",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 539,
    height: 539
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M538.182 0H0V538.182H538.182V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19726_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.021 0.000264127C223.968 -0.0629359 179.624 11.2167 140.085 32.7979H277.638C317.083 34.2189 355.544 45.4949 389.505 65.5969C423.466 85.6979 451.845 113.984 472.048 147.87C492.25 181.756 503.633 220.159 505.157 259.574C506.681 298.989 498.296 338.157 480.768 373.498H269.021C248.596 373.454 228.629 367.441 211.58 356.202C194.531 344.963 181.141 328.987 173.061 310.241C164.982 291.494 162.563 270.796 166.102 250.694C169.644 230.592 178.99 211.964 192.989 197.102H78.9427C67.4772 227.512 63.4762 260.228 67.2758 292.503C71.0754 324.778 82.5644 355.673 100.779 382.595C118.994 409.518 143.404 431.682 171.96 447.231C200.517 462.779 232.39 471.256 264.902 471.954H435.974H445.287C456.74 461.965 467.338 451.038 476.966 439.284H435.782H269.021C243.303 439.265 217.921 433.44 194.773 422.243C171.624 411.047 151.306 394.766 135.337 374.621C119.369 354.474 108.162 330.982 102.555 305.901C96.9476 280.818 97.0851 254.794 102.956 229.772H136.79C130.716 250.315 129.524 271.992 133.308 293.077C137.093 314.16 145.75 334.072 158.589 351.224C171.429 368.377 188.098 382.299 207.269 391.882C226.441 401.465 247.584 406.443 269.021 406.423H500.219C524.508 365.601 537.547 319.08 538.012 271.588C538.475 224.097 526.347 177.331 502.859 136.043C479.372 94.7549 445.363 60.4179 404.291 36.5229C363.219 12.6276 316.547 0.0263641 269.021 0.000264127Z",
    fill: "url(#paint0_radial_19726_8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.388 504.733C220.962 503.308 182.523 492.038 148.576 471.95C114.63 451.864 86.2598 423.6 66.0546 389.741C45.8488 355.88 34.4521 317.502 32.9042 278.109C31.3564 238.715 39.707 199.562 57.1936 164.223H269.005C289.417 164.279 309.368 170.296 326.406 181.531C343.443 192.768 356.822 208.735 364.9 227.468C372.977 246.2 375.399 266.885 371.871 286.977C368.342 307.069 359.015 325.692 345.035 340.556H459.082C470.659 309.817 474.611 276.735 470.6 244.139C466.589 211.54 454.736 180.399 436.054 153.379C417.371 126.358 392.417 104.263 363.325 88.9826C334.233 73.7026 301.869 65.6936 269.005 65.6406H92.7384C81.2525 75.5946 70.6532 86.5256 61.0584 98.3116H98.7576H264.696H269.005C294.661 98.3456 319.978 104.163 343.073 115.328C366.169 126.493 386.448 142.719 402.401 162.798C418.353 182.878 429.571 206.294 435.215 231.303C440.86 256.313 440.788 282.275 435.005 307.252H401.046C406.997 286.768 408.102 265.18 404.273 244.196C400.442 223.212 391.783 203.404 378.975 186.34C366.169 169.274 349.568 155.418 330.482 145.865C311.397 136.313 290.349 131.326 269.005 131.299H37.7423C7.63278 181.956 -4.99818 241.091 1.79029 299.619C8.57874 358.147 34.4111 412.828 75.3177 455.26C116.224 497.692 169.941 525.526 228.216 534.487C286.491 543.449 346.097 533.04 397.877 504.86H260.388V504.733Z",
    fill: "url(#paint1_radial_19726_8)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_19726_8",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(301.841 236.041) scale(236.204 236.04)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A097D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#8D31A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A097D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_19726_8",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.7231 -31.6756) scale(981.564 980.884)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A097D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#6A097D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A097D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChronoxAiIcon);
export default __webpack_public_path__ + "static/media/Chronox AI Icon.7508c1b25658cdbf53bde8d756f1aad9.svg";
export { ForwardRef as ReactComponent };